import {} from "@tabler/icons-react";

const ResumeSentPage = () => {
    return (
        <div className="flex h-full max-w-xl flex-1 flex-col items-center justify-center gap-8 p-8">
            <h2 className="text-center font-bold text-[30px]">Vielen Dank</h2>

            <div className="flex flex-col gap-4">
                <p className="text-center">
                    Ihr Lebenslauf wird bei uns automatisch im System
                    hinterlegt. Sie müssen ihn daher nicht extra zuschicken.
                </p>

                <p className="text-center">
                    Zudem sollten Sie in Kürze den Lebenslauf an Ihre angegebene
                    E-Mail-Adresse zugeschickt bekommen.
                </p>

                <p className="text-center">
                    Für alles Weitere werden wir uns in den nächsten Tagen
                    zeitnah wieder persönlich bei Ihnen melden.
                </p>
            </div>
        </div>
    );
};

export { ResumeSentPage };
